<template>
  <v-app
    :light="!dark"
    :dark="dark"
  >
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      dark: false
    };
  }
};
</script>
